import React, { useContext } from "react";

import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

const PastBalanceBtn = ({ data, cache }) => {
  const { togglePopUp } = useContext(PopUpContext);

  return data?.summary?.opening_balance_id ? (
    <div className="download-balance-btn-area">
      <button
        onClick={() =>
          togglePopUp({
            form: "teacher-past-balance-pop-up",
            cache,
          })
        }
      >
        {lbl.OpeningBalance}
      </button>
    </div>
  ) : null;
};

export default PastBalanceBtn;
